import {
  ImageOutlined,
  InsertDriveFileOutlined,
  PictureAsPdfOutlined,
} from "@mui/icons-material";

/**
 * FileIcon
 * Renders an icon based on the file's MIME type.
 */
const FilePreviewImageTypeIcon = ({
  contentType,
  size = 48,
  color = "text.secondary",
}) => {
  if (contentType?.startsWith("image/")) {
    return <ImageOutlined className="thin" sx={{ fontSize: size, color }} />;
  }
  if (contentType === "application/pdf") {
    return (
      <PictureAsPdfOutlined className="thin" sx={{ fontSize: size, color }} />
    );
  }
  return (
    <InsertDriveFileOutlined className="thin" sx={{ fontSize: size, color }} />
  );
};

export default FilePreviewImageTypeIcon;
